export default "{\n    \"label\": \"Capteur\",\n    \"options\": {\n        \"true\": \"A un capteur\"\n    }\n}\n"